import { render, staticRenderFns } from "./InformationBulb.vue?vue&type=template&id=03a67cbc&"
import script from "./InformationBulb.vue?vue&type=script&lang=ts&"
export * from "./InformationBulb.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports